import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Platform-agnostic hook for shell navigation logic.
 * Provides navigation utilities including active route detection.
 */
export function useShellNavigation() {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive = useCallback(
    (path: string) => {
      if (path === '/') {
        return location.pathname === '/';
      }
      return location.pathname.startsWith(path);
    },
    [location.pathname],
  );

  const navigateToLogin = useCallback(() => {
    const currentPath = location.pathname + location.search + location.hash;
    navigate(`/login?after=${encodeURIComponent(currentPath)}`);
  }, [location, navigate]);

  return {
    location,
    navigate,
    isActive,
    navigateToLogin,
  };
}
